/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 03:08 pm
 * Last Modified: Tuesday, 24-07-23 01:51 pm, by Harper Yan
 */
import { useRouter } from 'next/router';
import { Breadcrumbs as MuiBreadcrumbs, BreadcrumbsProps as MuiBreadcrumbsProps } from '@mui/material';
import { Icon } from '@/Icon';
import { StyledLastItem, StyledLink } from './style';
export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: (_label: string) => void;
}
export interface BreadcrumbsProps extends Pick<MuiBreadcrumbsProps, 'sx'> {
  items: BreadcrumbItem[];
}
function Breadcrumbs(props: BreadcrumbsProps) {
  const {
    items,
    ...others
  } = props;
  const router = useRouter();
  return <MuiBreadcrumbs aria-label="breadcrumb" separator={<Icon name="ArrowForward" sx={{
    color: '#707A8A',
    width: '16px',
    height: '16px'
  }} />} {...others} data-sentry-element="MuiBreadcrumbs" data-sentry-component="Breadcrumbs" data-sentry-source-file="Breadcrumbs.tsx">
      {items.map((item, index) => {
      if (index === items.length - 1) {
        return <StyledLastItem key={item.label}>{item.label}</StyledLastItem>;
      }
      return <StyledLink color="inherit" href={item.href} key={item.label} onClick={e => {
        if (item.onClick) {
          e.preventDefault();
          item.onClick?.(item.label);
        } else {
          if (item.href?.startsWith('http')) {
            return;
          }
          e.preventDefault();
          void router.push(item.href!);
        }
      }} underline="none">
            {item.label}
          </StyledLink>;
    })}
    </MuiBreadcrumbs>;
}
export default Breadcrumbs;